import { Injectable } from '@angular/core';
import { PrintReportJSON } from '@compiere-ws/models/compiere-print-report-json';
import { AppConfig } from '@iupics-config/app.config';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable()
export class PrintReportService {
  private urlPrint: string;

  constructor(private http: ApiService, private config: AppConfig) {}

  printReport(dataForReport: PrintReportJSON): Observable<any> {
    this.urlPrint = this.config.getProcessRunnerResource('printReport');
    return this.http.post(this.urlPrint, dataForReport);
  }

  downloadReport(urlDownload: string): Observable<any> {
    return this.http.get<any>(this.config.getProcessRunnerResource() + urlDownload, {
      responseType: 'blob' as 'json',
      observe: 'response'
    });
  }
}
